export enum HttpRequestMethod {
  get = 'GET',
  post = 'POST',
  put = 'PUT',
  delete = 'DELETE',
  options = 'OPTIONS',
  head = 'HEAD',
  patch = 'PATCH',
}
